import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { updateMyReservation } from '../redux/slices/myselfSlice';

const UserCancelReservationModal = ({
  setCancelModal,
  selectedReservation,
  setSelectedReservation,
}) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.myself.loading);

  const cancelReservation = async () => {
    if (selectedReservation) {
      try {
        setCancelModal(false);

        await dispatch(
          updateMyReservation({
            ...selectedReservation,
            reservationStatus: 'canceled',
          })
        ).unwrap();

        setSelectedReservation(null);
      } catch (error) {
        toast.error('Could not cancel the reservation. Please try again.');
      }
    } else {
      toast.error('No reservation selected. Please try again.');
    }
  };

  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-8 rounded-md shadow-lg w-1/2 max-w-lg">
        <form>
          <label className="block mb-2 text-lg font-bold">
            Are You Sure You Want To <span className="text-red-500"> Cancel </span> Your
            Reservation?
          </label>
          <div className="flex justify-end">
            <button
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-md"
              type="button"
              onClick={() => cancelReservation()}
              disabled={loading}
            >
              {loading ? 'Canceling...' : 'Confirm'}
            </button>
            <button
              className="ml-4 bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded-md"
              onClick={() => setCancelModal(false)}
              type="button"
              disabled={loading}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export { UserCancelReservationModal };
